import { getEnums } from '@/api/common'
export default {
  state: () => {
    return {
      enumsData: {}
    }
  },
  mutations: {
    setEnumsData(state, data) {
      let enumsData = {}
      Object.keys(data).forEach(key => {
        enumsData[key] = data[key].map(item => {
          return {
            title: item.name,
            value: item.code,
            key: item.code
          }
        })
      })
      state.enumsData = enumsData
      if (Object.keys(enumsData).length) {
        sessionStorage.setItem('enumsData', JSON.stringify(enumsData))
      } else {
        sessionStorage.removeItem('enumsData')
      }
      
    }
  },
  actions: {
    // 获取系统枚举值
    async getEnumsData(context, data) {
      try {
        const res = await getEnums()
        context.commit('setEnumsData', res.data.collection[0])
        return Promise.resolve(res)
      } catch (error) {
        return Promise.reject(error)
      }
    }
  }
}
